import {View} from "@dp-instant/2d";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";
import {Container} from "pixi.js-legacy";
import {ArrowsView} from "./ArrowsView";

@injectable()
export class FieldView extends View {
    @inject(TypesGame.views.arrows)
    public readonly arrows: ArrowsView;
    public readonly labels = new Container();
    public readonly map = new Container();
    public readonly capitals = new Container();
    public readonly fighters = new Container();
    public readonly shapes = new View();

    onAdded() {
        this.addChild(this.map);
        this.map.addChild(this.shapes);
        this.map.addChild(this.fighters);
        this.map.addChild(this.capitals);
        this.map.addChild(this.labels);
        this.addChild(this.arrows);
        super.onAdded();
    }
}
